import { mapState, mapActions, mapGetters } from 'vuex';
import * as Msal from 'msal';

export default {
  props: {
    content: {
      type    : Object,
      default : ''
    },
    title: {
      type    : String,
      default : ''
    }
  },
  data() {
    return {
      newLink            : null,
      collabLink         : null,
      provider           : null,
      recordList         : [],
      openRecordList     : false,
      isLoadingRecords   : false,
      isLoadingAccessUrl : false,
      isProcessingRecord : false,
      msalConfig         : {
        auth: {
          clientId    : null,
          authority   : null,
          redirectUri : window.location.origin
        },
        cache: {
          cacheLocation          : 'localStorage',
          storeAuthStateInCookie : true
        }
      }
    };
  },
  watch: {
    'content.contextId': {
      handler: function() {
        if (this.content.hasEnded && this.content.type === 'collab') {
          this.getRecords();
        };
      },
      deep: true
    }
  },
  mounted() {
    if (this.content.type === 'collab') {
      if (this.content.hasEnded) {
        this.getRecords();
      } else {
        this.getCollabURL();
      }
    }
  },
  computed: {
    ...mapState({
      language: state => state._core.locales.current
    }),
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    ...mapGetters({
      getEmail : '_core/user/getEmail',
      getName  : '_core/user/getName'
    })
  },
  methods: {
    ...mapActions({
      actionGetWebconferenceProvider    : 'plataforma/content/getWebconferenceProvider',
      actionReintegrateWebconference    : 'plataforma/content/actionReintegrateWebconference',
      actionSetWebconferenceIntegration : 'plataforma/content/actionSetWebconferenceIntegration',
      actionGetCollabURL                : 'plataforma/content/actionGetCollabURL',
      actionGetCollabRecords            : 'plataforma/content/actionGetCollabRecords',
      actionGetCollabRecordURL          : 'plataforma/content/actionGetCollabRecordURL'
    }),
    getRecordDescription(length) {
      switch (length) {
        case 0:
          return this.$t('contentType.webconference.eventEnded');
        case 1:
          return this.$t('contentType.webconference.watchRecord');
        default:
          return this.$t('contentType.webconference.availableRecordings');
      }
    },
    getRecordIcon(length) {
      switch (length) {
        case 1:
          return 'mdi-play-circle-outline';
        default:
          return 'mdi-chevron-down';
      }
    },
    getJoinDescription() {
      if (this.content.allowJoinWebconference) {
        return this.$t('contentType.webconference.joinConference');
      } else {
        return this.$t('contentType.webconference.soon');
      }
    },
    async microsoftLogin(provider) {
      const msalInstance = new Msal.UserAgentApplication(this.msalConfig);
      await msalInstance.loginPopup();
      const { accessToken } = await msalInstance.acquireTokenSilent({ scopes: ['user.read'] });
      return accessToken;
    },
    async checkMicrosoftToken(provider) {
      const msalInstance = new Msal.UserAgentApplication(this.msalConfig);
      try {
        const { accessToken } = await msalInstance.acquireTokenSilent({ scopes: ['user.read'] });
        return accessToken;
      } catch {
        return this.microsoftLogin();
      }
    },
    async reintegrate() {
      this.$nuxt.$loading.start();
      try {
        const { provider } = await this.actionGetWebconferenceProvider();

        const {
          alias,
          externalAccountId,
          externalTenantId
        } = provider;

        this.msalConfig.auth.clientId = externalAccountId;
        this.msalConfig.auth.authority = `https://login.microsoftonline.com/${externalTenantId}`;

        if (alias === 'teams') {
          const accessToken = await this.checkMicrosoftToken();
          this.provider = provider;
          this.provider.accessToken = accessToken;
        } else {
          this.provider = provider;
        }

        const data = {
          content: { ...this.content }
        };

        data.content.provider = this.provider;
        data.content.title = this.title;
        data.content.startAt = this.removeTimeZone(
          data.content.startAt.replace(' ', 'T')
        );
        data.content.endAt = this.removeTimeZone(
          data.content.endAt.replace(' ', 'T')
        );
        data.content.subject = this.getEmail;

        this.newLink = await this.actionReintegrateWebconference({
          data,
          topicId: this.content.topicId
        });

        this.actionSetWebconferenceIntegration({
          topicId : this.content.topicId,
          value   : true
        });
        this.$nuxt.$loading.finish();
      } catch (err) {
        this.$nuxt.$loading.finish();
        this.$toast.error(err);
      }
    },
    removeTimeZone(value) {
      if (value) {
        return value.substring(0, 19);
      } else {
        return value;
      }
    },
    async getRecords() {
      this.isLoadingRecords = true;

      try {
        const { results } = await this.actionGetCollabRecords({ contextId: this.content.contextId });
        this.recordList = results;
        this.isProcessingRecord = this.recordList.some(record => record.status === 'PROCESSING');
        await this.getRecordsURL(this.recordList);
      } catch (err) {
        this.$toast.error(this.$t('contentType.webconference.errorOnAccessRecord'));
      } finally {
        this.isLoadingRecords = false;
      }
    },
    checkRecordsLength(event) {
      if (this.recordList.length === 1) {
        this.openWebConference(event, this.recordList[0].url);
      } else {
        this.openRecordList = true;
      }
    },
    async getRecordsURL(recordList) {
      for (const record of recordList) {
        if (record.status === 'PROCESSING') {
          this.$toast.error(this.$t('contentType.webconference.proccessingRecord'));
        } else if (record.status === 'DONE') {
          const { url } = await this.actionGetCollabRecordURL({ recordId: record.id });

          record.url = url;
        } else {
          this.$toast.error(this.$t('contentType.webconference.errorOnAccessRecord'));
        }
      }
    },
    async getCollabURL() {
      this.$nuxt.$loading.start();

      this.isLoadingAccessUrl = true;

      const data = {
        sessionId : this.content.link,
        email     : this.getEmail,
        name      : this.getName
      };

      try {
        const url = await this.actionGetCollabURL(data);

        this.collabLink = url;
      } catch (err) {
        this.$toast.error(this.$t('contentType.webconference.linkGeneratorError'));
      } finally {
        this.isLoadingAccessUrl = false;
        this.$nuxt.$loading.finish();
      }
    },
    openWebConference(e, url) {
      if (this.content.type === 'collab' && url) {
        e.preventDefault();
        window.open(url);
      } else if (this.content.link) {
        window.open(this.content.link);
      }
    },
    emitProgress() {
      this.$nuxt.$emit('student-section', {
        type : 'markProgress',
        data : this.content.topicId
      });
    }
  }
};
